<!-- @ts-nocheck -->
<template>
  <a-spin :spinning="props.loading" wrapper-class-name="ll-table-spin-wrapper">
    <div :class="bem.b()">
      <!-- 头部seach -->
      <header-search
        v-bind="headerSearchProps"
        :header-search-height="headerSearchHeight"
        @change="handleSwitchMenuChange"
        @change-header-search="handleChangeHeaderSearch"
      >
        <!-- header-slot -->
        <template #header>
          <slot name="header" />
        </template>
        <!-- left-slot -->
        <template #headerLeft>
          <slot name="headerLeft"></slot>
        </template>
        <!-- middle-slot -->
        <template #headerMiddle>
          <slot name="headerMiddle"></slot>
        </template>
        <!-- right-slot -->
        <template #headerRight>
          <slot name="headerRight"></slot>
        </template>
      </header-search>
      <!-- slot-content table和card默认table -->
      <div
        ref="tableRef"
        :class="[
          bem.m('fixed-height'),
          !newNaTableptions.dataSource!.length ? bem.m('empty') : ''
        ]"
      >
        <slot :name="contentType">
          <main-table
            v-bind="newNaTableptions"
            @handle-change-data-source="handleChangeDataSource"
          >
            <!-- tableHeaderCell-slot -->
            <template #tableHeaderCell="slots">
              <slot name="tableHeaderCell" v-bind="slots"></slot>
            </template>
            <!-- tableBodyCell-slot -->
            <template #tableBodyCell="slots">
              <slot name="tableBodyCell" v-bind="slots"></slot>
            </template>
            <!--tableOperate-slot -->
            <template #tableOperate="slots">
              <slot name="tableOperate" v-bind="slots"></slot>
            </template>
            <!-- tableRowExpand-slot -->
            <template v-if="$slots.expandedRow" #expandedRow="slots">
              <slot name="expandedRow" v-bind="slots"></slot>
            </template>
            <!-- expandColumnTitle-slot -->
            <template #expandedTitle>
              <slot name="expandedTitle"> </slot>
            </template>
            <!-- empty-slot -->
            <template #emptyText>
              <slot name="emptyText"></slot>
            </template>
            <!-- customFilterDropdown-slot -->
            <template
              v-if="$slots.customFilterDropdown"
              #customFilterDropdown="slots"
            >
              <slot name="customFilterDropdown" v-bind="slots"></slot>
            </template>
            <!-- customFilterIcon-slot -->
            <template v-if="$slots.customFilterIcon" #customFilterIcon="slots">
              <slot name="customFilterIcon" v-bind="slots"></slot>
            </template>
            <!-- summary-slot -->
            <template v-if="$slots.summary" #summary="slots">
              <slot name="summary" v-bind="slots"></slot>
            </template>
            <!-- summary-slot -->
            <template v-if="$slots.expandIcon" #expandIcon="slots">
              <slot name="expandIcon" v-bind="slots"></slot>
            </template>
          </main-table>
        </slot>
      </div>
      <!-- 底部分页 -->
      <slot name="footerPage">
        <!-- <template
          v-if="
          newNaTableptions.dataSource!.length &&
          !newNaTableptions.hiddenPagination
        "
        >
          <pagination v-bind="paginationProps" />
        </template> -->
      </slot>
    </div>
  </a-spin>
</template>
<script lang="ts" setup>
// @ts-nocheck
import { provide, ref, watch } from 'vue'

import {
  HEADER_SRARCH_HEIGHT,
  ImenuSwitchType,
  PAGINATION_HEIGHT,
} from '@ll-plus/components/table/src/config'
import { createNamespace } from '@ll-plus/utils'
import { proTableProps } from './config'

import HeaderSearch from './components/header-search.vue'
import MainTable from './components/main-table.vue'

// 1.defineOptions
defineOptions({ name: 'LlProTable' })

// 2.props
const props = defineProps(proTableProps)
// 3.ref
// 表格数据
const originDataSource = ref()
const newNaTableptions = ref<any>({
  dataSource: [],
  columns: [],
})
// 菜单切换/内容插槽
const contentType = ref(ImenuSwitchType.TABLE) // 菜单切换
const headerSearchHeight = ref(HEADER_SRARCH_HEIGHT) // 头部内容默认高度
const tableRef = ref()
const bem = createNamespace('table')

// 4.methods
// 拖拽完成后获取拖拽后的数据
const handleChangeDataSource = (dataSource: any[]) => {
  newNaTableptions.value.dataSource = dataSource
}
// 切换菜单内容
const handleSwitchMenuChange = (v: ImenuSwitchType) => {
  contentType.value = v
}
// 改变头部高度
const handleChangeHeaderSearch = (height: number) => {
  if (headerSearchHeight.value === height) return
  headerSearchHeight.value = height
}

// 5.watch
watch(
  () => props.tableProps,
  (newValue: any) => {
    if (newValue) {
      newNaTableptions.value = { ...newValue }
      originDataSource.value = [...newValue.dataSource]
      contentType.value = newNaTableptions.value.contentType
    }
  },
  {
    deep: true,
    immediate: true,
  }
)
// 根据头部和分页高度动态设置表格的高度
watch(
  () => [tableRef, headerSearchHeight],
  () => {
    if (tableRef.value) {
      const diffHeight = headerSearchHeight.value + 20 + PAGINATION_HEIGHT + 10
      tableRef.value.style.height = `calc(100% - ${diffHeight}px)`
    }
  },
  {
    immediate: true,
    deep: true,
  }
)

// 6.其他
provide('contentType', contentType)
</script>
